/**
 * Inbound-SMS turns (built by the infra `agent-inbound-sms` Lambda via the
 * shared `_shared/channel-prompt.ts`) wrap the user's verbatim text between a
 * model-only CHANNEL CONTEXT preamble and a labelled delimiter. That preamble
 * is identical and unhelpful in the UI, so the console redacts it for display:
 * the chat shows a "via SMS" chip plus the user's message.
 *
 * Detection keys on the stable `----- USER MESSAGE (verbatim) -----` delimiter —
 * kept in sync with `USER_MESSAGE_DELIMITER` in the infra channel-prompt helper
 * and the runtime's `stripChannelPreamble`. DISPLAY transform only: the stored
 * turn text and what the agent saw are unchanged.
 */

const USER_MESSAGE_DELIMITER = '----- USER MESSAGE (verbatim) -----';
const CLOSING_DELIMITER = '-----------------------------------';

export interface SmsRedaction {
  /** Whether the turn is an inbound-SMS turn (it has the channel delimiter). */
  readonly isSms: boolean;
  /** Text to display: the verbatim message for SMS turns, else the original. */
  readonly body: string;
}

/** Strip the SMS channel preamble for display, keeping the verbatim message. */
export function redactSmsPreamble(text: string): SmsRedaction {
  const start = text.indexOf(USER_MESSAGE_DELIMITER);
  if (start === -1) {
    return { isSms: false, body: text };
  }
  let body = text.slice(start + USER_MESSAGE_DELIMITER.length);
  const close = body.lastIndexOf(CLOSING_DELIMITER);
  if (close !== -1) {
    body = body.slice(0, close);
  }
  return { isSms: true, body: body.trim() };
}
